import React, { useState } from "react";
import axios from "axios";
import BASE_URL from "../../../../config/apiConfig";

const WeatherNotificationScheduler = () => {
  const [time, setTime] = useState("");
  const [loading, setLoading] = useState(false);

  const scheduleNotification = async () => {
    if (!time) {
      alert("Please select a time for the notification.");
      return;
    }
    try {
      setLoading(true);
      await axios.post(`${BASE_URL}/api/admin/notifications/schedule-weather`, {
        job_type: "scheduled",
        scheduled_time: time,
      });
      alert("Notification scheduled successfully!");
    } catch (error) {
      console.error("Error scheduling notification:", error);
      alert("Failed to schedule notification.");
    } finally {
      setLoading(false);
    }
  };

  const sendNow = async () => {
    try {
      setLoading(true);
      await axios.post(`${BASE_URL}/api/notifications/weather-scheduler`, {
        job_type: "instant",
      });
      alert("Notification sent successfully!");
    } catch (error) {
      console.error("Error sending notification:", error);
      alert("Failed to send notification.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.header}>Weather Notification Scheduler</h1>
      <div style={styles.card}>
        <div style={styles.inputContainer}>
          <label style={styles.label}>
            Select Time:
            <input
              type="datetime-local"
              value={time}
              onChange={(e) => setTime(e.target.value)}
              style={styles.input}
            />
          </label>
        </div>
        <div style={styles.buttonContainer}>
          <button
            onClick={scheduleNotification}
            disabled={loading}
            style={styles.button}
          >
            {loading ? "Scheduling..." : "Schedule Notification"}
          </button>
        </div>
      </div>
      <div style={styles.card}>
        <div style={styles.buttonContainer}>
          <button onClick={sendNow} disabled={loading} style={styles.button}>
            {loading ? "Sending..." : "Send Now"}
          </button>
        </div>
      </div>
    </div>
  );
};

// CSS-in-JS styles
const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    backgroundColor: "#f4f7fc",
    minHeight: "100vh",
  },
  header: {
    color: "#2c3e50",
    fontSize: "2rem",
    marginBottom: "20px",
    textAlign: "center",
  },
  card: {
    backgroundColor: "#ffffff",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    width: "100%",
    maxWidth: "500px",
    marginBottom: "20px",
  },
  inputContainer: {
    marginBottom: "15px",
  },
  label: {
    fontSize: "1rem",
    color: "#34495e",
    marginBottom: "8px",
    display: "block",
  },
  input: {
    width: "100%",
    padding: "10px",
    fontSize: "1rem",
    border: "1px solid #ddd",
    borderRadius: "8px",
    outline: "none",
    marginBottom: "10px",
    boxSizing: "border-box",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
  },
  button: {
    backgroundColor: "#3498db",
    color: "#fff",
    padding: "10px 20px",
    fontSize: "1rem",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "background-color 0.3s",
    width: "100%",
    maxWidth: "250px",
  },
  buttonHover: {
    backgroundColor: "#2980b9",
  },
  disabledButton: {
    backgroundColor: "#7f8c8d",
    cursor: "not-allowed",
  },
};

export default WeatherNotificationScheduler;
